import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import BaseEditationComponent from 'src/app/class/BaseEditationComponent';
import { NotifierService } from 'angular-notifier';
import { CommService } from './../../../comm.service'; // uprav podle své struktury
import { Router } from '@angular/router';

@Component({
  selector: 'app-kartab-editace',
  templateUrl: './editace.component.html',
  styleUrls: ['./../../../app.component.css'],
})
export class EditaceKartaBComponent extends BaseEditationComponent implements OnInit, OnDestroy {

  data: any[] = [];
  users: any[] = [];
  response: any;
  

  @ViewChild('formRef') formRef: NgForm;

  ngAfterViewInit() {
    // formRef bude k dispozici až zde
    console.log('Formulář připraven:', this.formRef);
  }

  submitForm() {
    if (this.formRef) {
      this.formRef.ngSubmit.emit();
    } else {
      console.warn('Formulář není ještě připraven.');
    }
  }

  getHeading() {
    return `Editace Karty B`;
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadData();
  }

  loadData() {
    this.getKartaB();
    this.loadUsers();
  }

  getKartaB() {
  const kartaBData = this.comm.kartaB;

  if (!kartaBData || !kartaBData.id) {
    this.notifier.notify('error', 'Chybí ID záznamu.');
    return;
  }

this.comm.getKartaB(kartaBData).subscribe(
  (response) => {
    const result = response.json();
    if (Array.isArray(result) && result.length) {
      const item = result[0];

      // Datum jako řetězec YYYY-MM-DD
      if (item.datum) {
          const d = new Date(item.datum);

          // Převeď na lokální časový string bez sekund
          const pad = (n: number) => n.toString().padStart(2, '0');
          const localDateTime = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

          item.datum = localDateTime;
        }

      // Převod na čísla jen pokud existují
      if (item.osoba !== undefined && item.osoba !== null) {
        item.osoba = +item.osoba;
      }

      if (item.operator !== undefined && item.operator !== null) {
        item.operator = +item.operator;
      }

      this.data = [item];
      console.log('✅ Získaná data:', item);
    } else {
      this.data = [];
    }
  }
);
  }

  loadUsers() {
    this.comm.users().index().subscribe(
      (response) => {
        this.users = response.json();
        console.log('✅ Načteni uživatelé:', this.users);
      },
      (error) => {
        console.error('❌ Chyba při načítání uživatelů:', error);
        this.notifier.notify('error', 'Nepodařilo se načíst seznam uživatelů.');
      }
    );
  }

  onSubmit(form: NgForm) {
    if (!this.data.length) {
      this.notifier.notify('error', 'Nelze uložit – data nejsou načtena.');
      return;
    }

    const formData = form.value;

    const souhrn = {
      id: this.data[0].id,
      datum: formData.datum || this.data[0].datum,
      osoba: +formData.osoba || this.data[0].osoba,
      operator: +formData.operator || this.data[0].operator,
      note: formData.note || this.data[0].note,
      operator_note: formData.operator_note || this.data[0].operator_note,
      check_visual: !!formData.check_visual,
      check_place: !!formData.check_place,
      check_training: !!formData.check_training,
      operator_visual: !!formData.operator_visual,
      operator_place: !!formData.operator_place,
      operator_training: !!formData.operator_training,
      funkcni_zkouska: !!formData.funkcni_zkouska,
      testovaci_sada: !!formData.testovaci_sada,
      kontrola1: !!formData.kontrola1,
      kontrola2: !!formData.kontrola2,
      kontrola3: !!formData.kontrola3,
      kontrola4: !!formData.kontrola4,
      kontrola5: !!formData.kontrola5,
    };

    console.log('📤 Odesílám souhrn:', souhrn);

    this.comm.updateKartaB(souhrn).subscribe(
      (response) => {
        this.response = response.json();
        this.notifier.notify('success', 'Záznam byl úspěšně uložen.');
        console.log('✅ Odpověď serveru:', this.response);
        // Přesměrování po úspěšném uložení
      this.router.navigate(['/kvalita/karta-b']);
      },
      (error) => {
        console.error('❌ Chyba při ukládání:', error);
        this.notifier.notify('error', 'Chyba při ukládání změn.');
      }
    );
  }
}
